import { Typography, useTheme } from "@material-ui/core";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { paymentMethodService } from "../../services/PaymentMethodService";
import Authorize from "../Authorize";
import Filteration from "../Filteration/Filteration";
import { RUDTable } from "../Table/RUDTable";
import UserContext from "../UserContext";
import AddPaymentMethod from "./AddPaymentMethod";

const PaymentMethod = () => {
    const [paymentMethodAdded, setPaymentMethodAdded] = useState(0);
    const [filter, setFilter] = useState({
        search: "",
    });
    const { user } = useContext(UserContext);
    const history = useHistory();

    const [clearFilters, setClearFilters] = useState(false);
    const theme = useTheme();

    const handleFilterClear = () => {
        setClearFilters(!clearFilters);
        setFilter({
            search: "",
        });
    };

    return (
        <>
            <Authorize
                opName="CREATE PAYMENT_METHOD"
                // fallback={
                //     <AuthorizeFallback message="You're not authorized to create a new employee" />
                // }
            >
                <AddPaymentMethod
                    setPaymentMethodAdded={setPaymentMethodAdded}
                />
            </Authorize>

            <RUDTable
                getter={(page, limit) =>
                    paymentMethodService.getPaymentMethod(page, limit, {
                        search: filter.search ? filter.search : null,

                        // role: filter.role ? filter.role : null,
                        // classroom: filter.classroom ? filter.classroom : null,
                    })
                }
                editor={paymentMethodService.updatePaymentMethod}
                deletor={(ids) =>
                    paymentMethodService.deletePaymentMethod(ids[0] as any)
                }
                readables={{
                    id: "ID",
                    name: "Name",
                    _description: "Description",
                }}
                rowsPreprocessor={(r) => ({
                    ...r,
                    deletionId: r.id,
                    _description: r.description ? (
                        r.description
                    ) : (
                        <Typography style={{ color: theme.palette.divider }}>
                            N/A
                        </Typography>
                    ),
                    description: r.description,
                })}
                ops={{
                    read: "READ PAYMENT_METHOD",
                    edit: "EDIT PAYMENT_METHOD",
                    delete: "DELETE PAYMENT_METHOD",
                }}
                updatingAgents={[paymentMethodAdded, filter.search]}
                editables={[
                    {
                        name: "name",
                        type: "textfield",
                        label: "Name",
                        isRequired: true,
                    },

                    {
                        name: "description",
                        type: "textfield",
                        label: "Description",
                        isRequired: false,
                    },
                ]}
                filters={
                    <Filteration
                        handleClear={handleFilterClear}
                        filter={filter}
                        setFilter={setFilter}
                    />
                }
                customCols={[]}
                storageKey="paymentMethod"
            />
        </>
    );
};

export default PaymentMethod;
